<section class="results-pane-value">
  <section class="profile-content" >
    <section class="item-section">
      <gen-curation-editor-aberration-details
        [readOnly]="readOnly"
        [curationItem]="_curationItem"
        [aberrationDetailsFormName]="aberrationDetailsFormName"
        [revisionTag]="revisionTag"
        [submitted]="submitted"
        [approvedMode]="approvedMode"
        [inlineEdit]="inlineEdit"
        [verticalForm]="verticalForm"
        [searchDataConfigParams]="searchDataConfigParams"
        (validated)="validationEvent($event)"
        [pubmedSearchURL]="pubmedSearchURL"
        [googleSearchURL]="googleSearchURL"
        (aberrationDataChanged)="aberrationDataChangedEvent($event)">
      </gen-curation-editor-aberration-details>
    </section>
    <section class="item-section">
      <gen-curation-editor-table-container
        [title]="'PubMed Links'"
        [readOnly]="readOnly"
        [tableData]="_curationItem.curationData['manualAnnotations']?.pubmedsLinks"
        [itemTitle]="''"
        [formName]="pubmedFormName"
        [revisionTag]="revisionTag"
        [approvedMode]="approvedMode"
        [userCreatedTag]="userCreatedTagPrefix"
        [submitted] = "submitted"
        [prioritizeAvailable] = "prioritizeAvailable"
        (itemChanged)="pubmedUpdate($event)"
      >
      </gen-curation-editor-table-container>
    </section>
    <section class="item-section">
      <gen-curation-editor-clinical-significances-container
        [readOnly]="readOnly"
        [curationData]="_curationItem?.curationData"
        [curationItem]="_curationItem"
        [diagnosticFormName]="diagnosticFormName"
        [prognosticFormName]="prognosticFormName"
        [therapeuticFormName]="therapeuticFormName"
        [revisionTag]="revisionTag"
        [submitted]="submitted"
        [approvedMode]="approvedMode"
        (validated)="validationEvent($event)"
        (itemDeleted)="deleteItem($event)"
        [searchDataConfigParams]="searchDataConfigParams"
        [googleSearchURL]="googleSearchURL"
        [pubmedSearchURL]="pubmedSearchURL">
      </gen-curation-editor-clinical-significances-container>
    </section>
    <section class="item-section">
      <gen-curation-editor-items-container
        [readOnly]="readOnly"
        [curationData]="_curationItem?.curationData"
        [curationItem]="curationItem"
        [title]="'Clinical Trials'"
        [itemTitle]="'Trial'"
        [vertical]="false"
        [tableVertical]="false"
        [viewAsTable]="false"
        [rootType]="clinicalTrialsRootName"
        [formName]="clinicalTrialsFormName"
        [revisionTag]="revisionTag"
        [submitted]="submitted"
        [approvedMode]="approvedMode"
        [searchDataConfigParams]="searchDataConfigParams"
        [googleSearchURL]="googleSearchURL"
        [pubmedSearchURL]="pubmedSearchURL"
        (validated)="validationEvent($event)"
        (itemDeleted)="deleteItem($event)">
      </gen-curation-editor-items-container>
    </section>
    <section class="item-section">
      <gen-curation-editor-items-container
        [readOnly]="readOnly"
        [curationData]="_curationItem?.curationData"
        [curationItem]="curationItem"
        [title]="'Cases'"
        [itemTitle]="'Case'"
        [vertical]="false"
        [tableVertical]="false"
        [viewAsTable]="false"
        [rootType]="casesRootName"
        [formName]="casesFormName"
        [revisionTag]="revisionTag"
        [submitted]="submitted"
        [approvedMode]="approvedMode"
        [searchDataConfigParams]="searchDataConfigParams"
        [googleSearchURL]="googleSearchURL"
        [pubmedSearchURL]="pubmedSearchURL"
        (validated)="validationEvent($event)"
        (itemDeleted)="deleteItem($event)">
      </gen-curation-editor-items-container>
    </section>
    <section class="item-section">
      <gen-curation-editor-summary
        [readOnly]="readOnly"
        [curationData]="_curationItem?.curationData"
        [formName]="summaryFormName"
        [title]="'Summary'"
        [summarySectionTitle]="'Summary'"
        [inlineEdit]="inlineEdit"
        [revisionTag]="revisionTag"
        [submitted]="submitted"
        [approvedMode]="approvedMode">
      </gen-curation-editor-summary>
    </section>
  </section>
</section>
